import { WEAK_SENSE_OF_URGENCY } from '../../../constants/rulesConstants';
import GemMeterBaseRule from '../GemMeterBaseRule';

const TIME_VALID = 48 * 60 * 60;
export default class CountdownTimerHourRule extends GemMeterBaseRule {
  static ruleId = WEAK_SENSE_OF_URGENCY.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return false;
    }
    const dayElement = element.getElementsByClassName('day-left');
    const hourElemennt = element.getElementsByClassName('hour-left');
    const minuteElement = element.getElementsByClassName('minute-left');
    const secondElement = element.getElementsByClassName('second-left');

    let day = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (dayElement.length > 0) {
      day = dayElement[0].getElementsByClassName('num')[0].innerText;
    }
    if (hourElemennt.length > 0) {
      hours = hourElemennt[0].getElementsByClassName('num')[0].innerText;
    }
    if (minuteElement.length > 0) {
      minutes = minuteElement[0].getElementsByClassName('num')[0].innerText;
    }
    if (secondElement.length > 0) {
      seconds = secondElement[0].getElementsByClassName('num')[0].innerText;
    }

    return Number(day) * 24 * 60 * 60 + Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds) < TIME_VALID;
    // return parseInt(element.getElementsByClassName('day-left')[0].getElementsByClassName('num')[0].innerText) < 2;
  }
}
